import React from 'react';
import PropTypes from 'prop-types';

import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';

const Calories = ({ calories }) => {
  const styles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  return (
    <MenuItemDescriptionTypography
      component="p"
      data-testid="calories-field"
      {...styles}
    >
      {calories}
    </MenuItemDescriptionTypography>
  );
};

Calories.propTypes = {
  calories: PropTypes.string.isRequired,
  typeVariant: PropTypes.string
};

export default Calories;
